<p-menu #menu [model]="items" [popup]="true" appendTo="body" />
<button type="button" class="locale-picker" (click)="toggle($event)">
  <i class="pi pi-globe"></i>
  <span class="locale-picker__label">{{ labelOf((current$ | async) ?? 'en') }}</span>
</button>
